// assets
import { BarChartOutlined, BellOutlined, FileTextOutlined, DotChartOutlined } from '@ant-design/icons';

// icons
const icons = {
  BarChartOutlined,
  BellOutlined,
  FileTextOutlined,
  DotChartOutlined
};

const reports = {
  id: 'group-reports',
  title: 'Reports & Notifications',
  type: 'collapse',
  icon: icons.FileTextOutlined,
  children: [
    {
      id: 'reports',
      title: 'Reports',
      type: 'item',
      url: '/reports',
      icon: icons.BarChartOutlined
    },
    {
      id: 'reports-graph',
      title: 'Graph View',
      type: 'item',
      url: '/reports/graph',
      icon: icons.DotChartOutlined
    },
    {
      id: 'notifications',
      title: 'Notifications',
      type: 'item',
      url: '/notifications',
      icon: icons.BellOutlined
    }
  ]
};

export default reports;
